import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChatBubble7: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chat-bubble-7"><path d="M12 20.75C17.1086 20.75 21.25 16.8325 21.25 12C21.25 7.16751 17.1086 3.25 12 3.25C6.89137 3.25 2.75 7.16751 2.75 12C2.75 13.9949 3.45574 15.8339 4.64394 17.3057C4.45609 18.3057 4.14616 19.2745 3.77778 20.2353C5.06428 20.1558 6.27508 19.953 7.44848 19.6192C8.7923 20.3391 10.3454 20.75 12 20.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconChatBubble7;
